import React from 'react';
import { get } from 'lodash';
import { SdfAlert } from '@synerg/react-components';

import Milestones from '../../projectDetails/milestones';
import { useApplicationState, updateCurrentDevProjectDetails } from '../../../utilities/applicationState';
import './projectCredentialsStyle.scss';

export default function DevMilestones() {
	const [store, dispatch] = useApplicationState();
	const { loadings, projects: { current } } = store;
	const { errorLoadingProject = false, devInfo = {} } = current;
	const { loadingProjectDetails = true } = loadings;
	const hasAssociatedProject = Boolean(get(devInfo, 'link', false));
	const milestones = get(devInfo, 'milestones', []);
	const canDisplayMilestones = Array.isArray(milestones) && milestones.length > 0;
	const finishedBeforeSPP = Array.isArray(milestones) && milestones.length === 0 && get(devInfo, 'complete', false);

	const onChangeMilestones = ({ type, change }) => {
		dispatch(updateCurrentDevProjectDetails({
			...(type === 'milestones' && { milestones: change }),
			...(type === 'startDate' && { startDate: change })
		}))
	};

	return (
		<div className="project-progress-section">
			<div className="flex justify-between items-center mb-6">
				<div className="text-heading-05 font-bold">Development Milestones</div>
				{hasAssociatedProject &&
					<SdfAlert
						status='success'
						size='sm'
						aria-live="polite"
						type="inline"
					>
						<div className="text-md font-bold">Production project has been generated.</div>
					</SdfAlert>
				}

				{finishedBeforeSPP &&
					<SdfAlert
						status='info'
						size='sm'
						aria-live="polite"
						type="inline"
					>
						<div className="text-md font-bold">This project was finished before Simplified Milestones.</div>
					</SdfAlert>
				}
			</div>

			{canDisplayMilestones && <div>
				{errorLoadingProject && <div>Not Available</div>}
				{!loadingProjectDetails &&
					<Milestones
						project={devInfo}
						milestones={milestones}
						onChange={onChangeMilestones}
					/>
				}
			</div>}
		</div>
	)
};
